import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import './skeleton.css';
import { SwiperSlide } from 'swiper/react';

// Constants
const COUNTS = {
    expertise: 6,
    resume: 4,
    skill: 16,
    threeEs: 3,
    certification: 3,
};

// Reusable Skeleton Components
const SliderSkeleton = () => (
    <Container className="py-5 BannerSk">
        <Row className="py-4">
            <Col lg={6} sm={12}>
                <div className="BannerSkTitle SkBgColor"></div>
                <p className="mt-3 BannerSkTyped SkBgColor"></p>
                <div className="mt-3 BannerSkLink SkBgColor"></div>
                <div className="mt-3 BannerSkLink SkBgColor"></div>
            </Col>
            <Col lg={6} sm={12}>
                <div className="p-3 BannerSkImg SkBgColor SkBorderRadius"></div>
            </Col>
        </Row>
    </Container>
);

const AboutSkeleton = () => (
    <>
        <Row className="BannerSk">
            <Col lg={8}>
                <div className="mb-3 BannerSkLink SkBgColor"></div>
                <div className="SkBgColor BannerSkPara"></div>
            </Col>
            <Col lg={4} className="mt-4 mt-lg-0">
                <div className="featured-box style-4">
                <div className="featured-box-icon SkBgColor SkBorderRadius"></div>
                <div className="SkBgColor BannerSkLink"></div>
                </div>
            </Col>
        </Row>
        <Row className="mt-4">
            {[...Array(4)].map((_, i) => (
                <Col key={i} xs={6} lg={3}>
                <div className="SkBgColor BannerSkLink mb-3"></div>
                <div className="SkBgColor BannerSkLink"></div>
                </Col>
            ))}
        </Row>
    </>
);

const ExpertiseSkeleton = () => (
    [...Array(COUNTS.expertise)].map((_, index) => (
        <Col lg={4} sm={6} key={index}>
            <div className="BannerSk featured-box text-center px-md-4">
                <div className="featured-box-icon SkBgColor SkBorderRadius BannerSkImgSmall"></div>
                <div className="SkBgColor BannerSkLink mb-3"></div>
                <p className="SkBgColor BannerSkExpt"></p>
            </div>
        </Col>
    ))
);

const ResumeSkeleton = () => (
    [...Array(COUNTS.resume)].map((_, index) => (
        <div className="BannerSk" key={index}>
            <div className="SkBgColor BannerSkLink mb-3"></div>
            <div className="SkBgColor BannerSkLink mb-3"></div>
            <p className="SkBgColor BannerSkLink"></p>
            <hr className="my-4" />
        </div>
    ))
);

const EducationSkeleton = () => (
    [...Array(COUNTS.threeEs)].map((_, index) => (
        <div className="BannerSk" key={index}>
            <div className="SkBgColor BannerSkLink mb-3"></div>
            <p className="SkBgColor BannerSkLink"></p>
            <p className="SkBgColor BannerSkLink"></p>
            <hr className="my-4" />
        </div>
    ))
);

const ThreeEsSkeleton = () => (
    [...Array(COUNTS.threeEs)].map((_, index) => (
        <div className="call-out BannerSk" key={index}>
            <div className="SkBgColor BannerSkLink mb-3"></div>
            <p className="SkBgColor BannerSkExpt"></p>
        </div>
    ))
);

const CertificationSkeleton = () => (
    [...Array(COUNTS.certification)].map((_, index) => (
        <Col key={index} lg={3} md={6} sm={12} className="BannerSk">
            <div className="certification rounded-lg">
            <div className="BannerSkTyped SkBgColor"></div>
            <div className="SkBgColor BannerSkLink" aria-hidden="true">Loading</div>
            <p className="SkBgColor BannerSkExpt"></p>
            </div>
        </Col>
    ))
);

const SkillSkeleton = () => (
    [...Array(COUNTS.skill)].map((_, index) => (
        <Col className="BannerSk" lg={3} md={6} sm={12} key={index}>
            <div className="SkBgColor BannerSkLink mb-3"></div>
        </Col>
    ))
);

const ContactSkeleton = () => (
    <Row className="g-5 mt-5">
        <Col lg={9} className="wow fadeInUp">
            <p className="SkBgColor BannerSkExpt"></p>
            <p className="SkBgColor BannerSkExpt"></p>
            <p className="SkBgColor BannerSkExpt"></p>
        </Col>                           
        <Col lg={3}>
            <Row>
                <Col lg={12} className="wow fadeInUp">
                    <p className="SkBgColor BannerSkLink"></p>
                    <p className="SkBgColor BannerSkLink"></p>
                    <hr />
                </Col>
                <Col lg={12} className="wow fadeInUp" data-wow-delay="0.2s">
                    <p className="SkBgColor BannerSkLink"></p>
                    <p className="SkBgColor BannerSkLink"></p>
                    <hr />
                </Col>
                <Col lg={12} className="wow fadeInUp" data-wow-delay="0.4s">
                    <p className="SkBgColor BannerSkLink"></p>
                    <p className="SkBgColor BannerSkLink"></p>
                </Col>
            </Row><br />
        </Col>
    </Row>
);

const BlogSkeleton = () => (
    [...Array(COUNTS.resume)].map((_, index) => (
        <div className="box wow p-4 mb-5 fadeInUp " key={index} data-wow-delay="0.4s">
            <Row>
                <Col className="col-12 col-md-6 col-lg-6 wow fadeInUp img-wrap">
                    <div className="FullHeight SkBgColor mb-3 rounded-lg BannerSk"></div>
                </Col>
                <Col className="col-12 col-md-6 col-lg-6 wow fadeInUp cont-wrap">
                    <ul className="social-icons sharing mb-2">
                        <li className="SkBgColor Category BannerSk"></li>
                        <li className="SkBgColor Category BannerSk"></li>
                        <li className="SkBgColor Category BannerSk"></li>
                    </ul>
                    <div className="BannerSkLink SkBgColor FullWidth mb-3"></div>
                    <ul className="social-icons sharing mb-3">
                        <li className="SkBgColor SkUlLi SkBorderRadius BannerSk"></li>
                        <li className="SkBgColor SkButton BannerSk"></li>
                        <li className="SkBgColor SkButton BannerSk"></li>
                    </ul>
                    <p className="SkBgColor BannerSkPara FullWidth mb-3"></p>
                    <div className="SkBgColor SkButton BannerSk"></div>
                </Col>
            </Row>
        </div>
    ))             
);

const CategorySkeleton = () => (
    <div className="swiper-wrapper">
        {[...Array(COUNTS.skill)].map((_, index) => (
            <SwiperSlide key={index}>
                <div className="cat-left">
                    <div className="SkBgColor Category BannerSk mb-2"></div>
                    <div className="SkBgColor Category BannerSk"></div>
                </div>
                <div className="SkBgColor SkUlLi BannerSk"></div>
            </SwiperSlide>
        ))}
    </div>
);

const SideCategorySkeleton = () => (
    [...Array(COUNTS.resume)].map((_, index) => (
        <p className="SkBgColor BannerSkLink" key={index}></p>
    ))
);

const PopularPostsSkeleton = () => (
    [...Array(COUNTS.threeEs)].map((_, index) => (
        <li key={index} className="d-flex align-items-start" style={{ width: '100%' }}>
            <div className="post-side-image side--30 pe-3">
                <div className="SkBgColor rounded-lg BannerSkExpt FullWidth"></div>
            </div>
            <div className="content_wrap side--70">
                <p className="SkBgColor BannerSkLink FullWidth mb-2"></p>
                <p className="SkBgColor Category FullWidth"></p>
            </div>
        </li>
    ))
);

const TagCloud = () => (
    [...Array(COUNTS.expertise)].map((_, index) => (
        <div key={index} className="d-flex align-items-start">
            <div className="SkBgColor Category BannerSk mb-2 me-2"></div>
            <div className="SkBgColor Category BannerSk mb-2 me-2"></div>
            <div className="SkBgColor Category BannerSk mb-2 me-2"></div>
        </div>
    ))
);

// Main Component
export default function Skeleton({ type }) {
    const skeletonMap = {
        slider: <SliderSkeleton />,
        about: <AboutSkeleton />,
        contact: <ContactSkeleton />,
        expertise: <ExpertiseSkeleton />,
        educations: <EducationSkeleton />,
        resume: <ResumeSkeleton />,
        skill: <SkillSkeleton />,
        '3es': <ThreeEsSkeleton />,
        certification: <CertificationSkeleton />,
        blog: <BlogSkeleton />,
        categories: <CategorySkeleton />,
        sidecategories: <SideCategorySkeleton />,
        popularposts: <PopularPostsSkeleton />,
        tagcloud: <TagCloud />
    };

    return skeletonMap[type] || null;
}
